import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DriverGpsLocation } from '../models/driver-gps-location';
import { DriverLocatableStop } from '../models/driver-locatable-stop';

/**
 * Keys a stop for LastDriverLocation: route stops are `r<id>`, Track Order rows `d<id>` once picked
 * up and `p<id>` before. Shared because the Route Tracking summary map and the "Show Driver Location"
 * modal look up the same rows and must not drift. /v2/RouteStops carries no `type`, so its rows take
 * the `r` branch.
 *
 * Unguarded on purpose: both call sites already hold a stop, and a missing one should fail here
 * rather than key as `rundefined` and reach the API as a request that can only 404.
 */
export const workOrderIdForStop = (stop: DriverLocatableStop): string =>
	(stop.type === 'ROUTESTOP' || !stop.type ? 'r' : stop.pickedUp ? 'd' : 'p') + stop.id;

@Injectable({
	providedIn: 'root'
})
export class DriverLocationService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/WorkOrders/:id/LastDriverLocation Get Drivers Last Location By Driver ID
	 * @apiName getDriversLastLocationByWorkOrderId
	 * @apiGroup WorkOrders
	 * @apiVersion 20.0.0
	 */
	getDriversLastLocationByWorkOrderId(workOrderId: string): Observable<DriverGpsLocation> {
		return this._http.get<DriverGpsLocation>(`${environment.apiUrl}/v2/WorkOrders/${workOrderId}/LastDriverLocation`);
	}
}
